import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const User = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14.765 14.4327C17.2559 13.3606 19 10.884 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 10.884 6.74405 13.3606 9.23499 14.4327C5.61721 15.5994 3 18.9941 3 23H4C4 18.5817 7.58172 15 12 15C16.4183 15 20 18.5817 20 23H21C21 18.9941 18.3828 15.5994 14.765 14.4327ZM12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8C18 11.3137 15.3137 14 12 14Z"
  />,
  'User'
)

export default User
